<template>
  <b-container class="manager-subscriptions">
    <!-- START MODAL CANCEL SUBSCRIPTION -->
    <b-modal
    modal-class="dsModal entrance"
    dialog-class="slide-in-left"
    id="modalCancelSubscriptionCentre"
    ref="modalCancelSubscriptionCentre"
    centered
    @ok="submitCancelSubscription"
    ok-title="Confirm"
    cancel-title="Discard"
    no-fade
    no-stacking
    size="lg"
    hide-backdrop
    no-title
  >
    <b-container>
      <div>
        <h2 class="form-header">
          <img
          src="../../../assets/images/icon-warning.png"
          alt="Logo"
          class=""
          />Cancelling Subscriptions
        </h2>
      </div>

      <b-form
        style="text-align: left"
        autocomplete="off"
        @submit.stop.prevent="submitCancelSubscription"
      >
      <b-input-group class="cancelReason">
        <b-form-group label="Why do you want to cancel?">
          <b-form-radio-group name="cancelReason"            
            v-model="$v.formCancelSubscription.cancelReason.$model"
            :state="validateInput('cancelReason')"
            aria-describedby="cancelReason-feedback">
            <b-form-radio value="NO_TIME_TO_USE">I don't have time to use it</b-form-radio>
            <b-form-radio value="DO_NOT_KNOW_HOW_TO_USE">I don't know how to use it</b-form-radio>
            <b-form-radio value="SECONDARY">It is secondary for me</b-form-radio>
            <b-form-radio value="REDUCE_EXPENSES">Reduce financial expenses</b-form-radio>
            <b-form-radio value="OTHER">Other reason</b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback :state="validateInput('cancelReason')" id="cancelReason-feedback" v-bind:tooltip="false">
          Please, select one option.
        </b-form-invalid-feedback>
        </b-form-group>
      </b-input-group>      
      <p class="information">
        By cancelling your subscription you will lose <b>Dropsmart's premium features</b>. You will still have access to a free and limited account.
      </p>
      <p class="text-cancel">
        To continue, please type CANCEL below:
      </p>
      <b-input-group class="cancel-input">
        <b-form-input
          type="text"
          name="confirmationText"
          size="md"
          placeholder=""
          v-model="$v.formCancelSubscription.confirmationText.$model"
          :state="validateInput('confirmationText')"
          aria-describedby="confirmationText-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="confirmationText-feedback" v-bind:tooltip="false"
          >You must type the word: CANCEL
          </b-form-invalid-feedback>
        </b-input-group>        
        <b-card v-if="formCancelSubscription.errorMessage">
          <b-card-body body-text-variant="danger">
            {{formCancelSubscription.errorMessage}}
          </b-card-body>
        </b-card>
      </b-form>

    </b-container>
    </b-modal>
    <!-- END MODAL CANCEL SUBSCRIPTION -->

    <div>
      <h2 class="form-header">Your subscription details</h2>
    </div>

    <div class="card mb-3 border-0" style="/*max-width: 540px;*/">
      <div class="row no-gutters">
        <div class="col-md-4">
          <img :src="mySubscriptionImg" class="card-img shadow" alt="Your Subscription Details" style="border-radius: 15px;">
        </div>
        <div class="col-md-8" style="align-self: center;">


        <!-- USER DOES NOT HAVE ACTIVE SUBSCRIPTION -->
        <div class="card-body  ml-5" v-if="customerInfo && customerInfo.user.plan && (customerInfo.user.plan.toUpperCase().startsWith('TRIAL') || customerInfo.user.plan.toUpperCase() === 'FREE') ">
          <h5 class="card-title" style="font-size: 1.5rem; font-weight: 700">Dropsmart App</h5>
          <p class="card-text">
          Dropsmart
          <!-- <span v-if="customerInfo.user.plan.toUpperCase().startsWith('TRIAL') ">Trial </span> -->
          <span v-if="shouldBehaveLikeFree">Free </span>
          <span v-else>Trial </span>
          </p>
          <p class="card-text"><small class="text-muted">You don't have any subscription yet.</small></p>
          <p v-if="!shouldBehaveLikeFree" class="card-text"><small class="text-muted">Trial ends on {{formatDate(customerInfo.user.trialEnd)}}</small></p>
          
          <!-- UPGRADE BUTTON -->
          <b-button href="https://join.dropsmart.io/checkout?period=yearly" class="font-weight-bold button-cancel-or-upgrade" variant="light">
            Click here and upgrade
          </b-button>
        </div>

        <!-- USER HAS ACTIVE OR CANCELING SUBSCRIPTION -->
        <!-- <div class="card-body  ml-5" v-else-if="customerLastSubscription && customerLastSubscription.status && customerLastSubscription.status === 'ACTIVE' || customerLastSubscription.status === 'CANCELING' "> -->
        <div class="card-body  ml-5" v-else-if="customerSubscriptionStatus && customerSubscriptionStatus === 'ACTIVE' || customerSubscriptionStatus === 'CANCELING' ">
          <h5 class="card-title" style="font-size: 1.5rem; font-weight: 700">Dropsmart App</h5>
          <p class="card-text">
            Dropsmart 
            <span>Premium {{customerLastSubscription.period}}</span>
          </p>
          <div v-if="customerLastSubscription.status">
            <p class="card-text"><small class="text-muted">{{formatSubscriptionStatus(customerSubscriptionStatus)}}</small></p>
            <p class="card-text"><small class="text-muted">Started on {{formatDate(customerLastSubscription.createdAt)}}</small></p>
            <p v-if="customerSubscriptionNextRenewal" class="card-text"><small class="text-muted">It will renew on {{formatDate(customerSubscriptionNextRenewal)}}</small></p>
            <p v-else-if="customerSubscriptionEndPeriod" class="card-text"><small class="text-muted">It will end on {{formatDate(customerSubscriptionEndPeriod)}}</small></p>
            
            <!-- CANCEL SUBSCRIPTION BUTTON IF STATUS IS ACTIVE-->
            <b-button v-if="customerSubscriptionStatus && customerSubscriptionStatus === 'ACTIVE' " v-b-modal.modalCancelSubscriptionCentre class="font-weight-bold button-cancel-or-upgrade" variant="light"
              @click="selectSubscription(customerLastSubscription.subscriptionId)">
              Cancel subscription
            </b-button>

            <!-- OTHERWISE UPGRADE BUTTON -->
            <b-button v-else href="https://join.dropsmart.io/checkout?period=yearly" class="font-weight-bold button-cancel-or-upgrade" variant="light">
              Click here and upgrade
            </b-button>
          </div>

        </div>

        <!-- USER HAS CANCELED OR SUSPENDED SUBSCRIPTION -->
        <!-- <div class="card-body  ml-5" v-else-if="customerLastSubscription && customerLastSubscription.status && customerLastSubscription.status === 'CANCELED' || customerLastSubscription.status === 'SUSPENDED' "> -->
        <div class="card-body  ml-5" v-else-if="customerSubscriptionStatus && customerSubscriptionStatus === 'CANCELED' || customerSubscriptionStatus === 'SUSPENDED' ">
          <h5 class="card-title" style="font-size: 1.5rem; font-weight: 700">Dropsmart App</h5>
          <p class="card-text">
            Dropsmart 
            <span>Premium {{customerLastSubscription.period}}</span>
          </p>
          <div v-if="customerSubscriptionStatus">
            <p class="card-text"><small class="text-muted">{{formatSubscriptionStatus(customerLastSubscription.status)}}</small></p>

            <!-- UPGRADE BUTTON -->
            <b-button href="https://join.dropsmart.io/checkout?period=yearly" class="font-weight-bold button-cancel-or-upgrade" variant="light">
              Click here and upgrade
            </b-button>
          </div>

        </div>

        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { BACKEND_URL } from "../../../config.js";
import { DateTime } from "luxon";
import mySubscription from "@/assets/images/centre/my-account/MySubscription.png";

export default {
  name: "SubscriptionDetails",
  props: ["customerInfo", "customerLastSubscription"],
  components: {
  },
  mounted() {
    let url = BACKEND_URL.LastSubscription.replace('VAR_CUSTOMER_ID', this.customerInfo.user.id);
    fetch(url, {
      method: "GET",
      // mode: 'cors',
      headers: {
        Accept: 'application/json',
        Authorization: this.customerInfo.token.token,
      },
    })
    .then(response => {
      if(response.ok) {
        return response.json();
      } else if (response.status == 404) {
        return null;
      }
    })
    .catch(()=>{ return null; })
    .then(subscriptions => {
      console.log(subscriptions != null ? JSON.stringify(subscriptions) : "User without any valid subscription.");
      // now this should be only the last subscription
      if (subscriptions) {
        this.customerSubscription = subscriptions;
        this.customerSubscriptionStatus = subscriptions.status;
        this.customerSubscriptionNextRenewal = subscriptions.nextRenewal;
        this.customerSubscriptionEndPeriod = subscriptions.endPeriod;
      }
    })
    .catch(error => {
          console.error(error);
    });
  },
  data() {
    return {
      mySubscriptionImg: mySubscription,
      accountStatusChanges: 0,
      formCancelSubscription: {
        cancelReason: null,
        confirmationText: null,
        subscriptionId: null,
        userEmail: null,
        errorMessage: null,
      },
      customerSubscription: null,
      customerSubscriptionStatus: null,
      customerSubscriptionNextRenewal: null,
      customerSubscriptionEndPeriod: null,
      showLoad: false,
    }
  },
  validations: {
    formCancelSubscription: {
      cancelReason: {
        required,
      },
      confirmationText: {
        sameAsCancel: sameAs(() => 'CANCEL'),
      }
    },
  },
  computed: {
    shouldBehaveLikeFree() {
      if(!this.customerInfo.user.paid) {
        if(this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying trial ended
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription && !this.customerLastSubscription.status) {
        return false;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
  },
  methods: {
    formatSubscriptionStatus(status) {
      if(status) {
        const word = status.toLowerCase(); 
        const capitalized = word.charAt(0).toUpperCase() + word.slice(1);
        return capitalized;
      }
      
    },
    formatDate(dt) {
      return DateTime.fromISO(dt).toISODate();
    },
    selectSubscription(subscriptionId) {
      console.log('Selected subscription ' + subscriptionId);
      this.formCancelSubscription.subscriptionId = subscriptionId;
    },
    validateInput(name) {
      const { $dirty, $error } = this.$v.formCancelSubscription[name];
      return $dirty ? !$error : null;
    },
    submitCancelSubscription(bvModalEvt) {
      this.$v.formCancelSubscription.$touch();
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      console.log("Error: " + this.$v.formCancelSubscription.$error);
      console.log("AnyError: " + this.$v.formCancelSubscription.$anyError);
      if (this.$v.formCancelSubscription.$anyError) {
        return;
      }

      this.showLoad = true;

      var url = BACKEND_URL.CancelSubscription.replace("VAR_CUSTOMER_ID", this.customerInfo.user.id);

      this.formCancelSubscription.userEmail = this.customerInfo.user.email;
      fetch(url, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(this.formCancelSubscription),
        headers: {
          Accept: "application/json",
          Authorization: this.customerInfo.token.token,
        },
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            //this.customerInfo.user.paid = false;
            //this.customerInfo.user.plan = null;
            this.accountStatusChanges++;
            //sessionStorage.setItem("customerInfo", JSON.stringify(this.customerInfo));            
            this.$refs.modalCancelSubscriptionCentre.hide();
            this.$emit('updated');
            this.customerSubscriptionStatus = 'CANCELING';
            console.log("The new subscription status is: " + this.customerSubscriptionStatus);
            this.customerSubscriptionEndPeriod = this.customerSubscriptionNextRenewal;
            this.customerSubscriptionNextRenewal = null;
          } else {
            return response.json().then(msg => {
              if (Object.prototype.hasOwnProperty.call(msg, "title")) {
                throw Error(msg.title);
              } else {
                throw Error(JSON.stringify(msg));
              }
            });
            
          }
        })
        .catch((error) => {
          console.error(error);
          this.formCancelSubscription.errorMessage = error.message;
        })
        .finally(() => {
          this.showLoad = false;
        });
    },
  }
}
</script>

<style lang="scss">
$color: #000000;

.button-cancel-or-upgrade {
  background: $color;
  color: #ffffff;
  border: none;
  border-radius: 0.4rem;
  font-size: 1rem;
  font-weight: 700;
  padding: 8px 24px 8px 24px;
  line-height: 25px;
}

.button-cancel-or-upgrade:hover {
  background: #E7E7E7;
  color: $color;
}

.button-cancel-or-upgrade:active,
.button-cancel-or-upgrade:focus {
  background: #000000 !important;
  color: #ffffff !important;
  border-color: #000000 !important;
  box-shadow: none !important;
  outline: none;
}

#modalCancelSubscriptionCentre {
  .modal-dialog {
    max-width: 100vw;
    margin: 0;
    height: 100vh;
    background: #ffffff;
    .invalid-feedback {
      color: #ff0000;
      padding-left: 10px;
    }
    .modal-header {
      border: 0;
      .close {
        margin: 0;
        font-size: 3.5rem;
        line-height: 28px;
        opacity: 1;
        padding: 1.5rem 1.5rem !important;
        &:focus {
          outline: none !important;
        }
      }
      .modal-title {
        display: none;        
      }
    }
    .modal-footer {
      border: 0;
      max-width: 410px;
      margin: 0 auto;
      padding: 0 15px;
      button {
        background-color: transparent;
        margin: 8px 0 0 8px;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 700;
        padding: 0;
        line-height: 38px;
        min-width: 110px;
        &:focus {
          outline: none;
          box-shadow: none;
        }
        &.btn-primary {
          order: 1;
          background-color: #DE0000;
          border-color: #DE0000;
          &:hover {
            background-color: #9C0001;
            border-color: #9C0001;
          }
        }
        &.btn-secondary {
          order: 2;
          border-color: #000000;
          color: #000000;
          &:hover {
            background-color: #000000;
            color: #ffffff;
          }
        }
      }
    }
    .modal-content {
      border: 0;
      border-radius: 0;
      display: block;
      height: 100vh;
    }
    .modal-body {
      max-width: 440px;
      margin: 0 auto;
      padding: 0;
      .information {
        padding: 0 15px;
      }
      .text-cancel {
        padding: 0 15px;
        margin: 0;
      }
      .cancel-input {
        padding: 0 15px;
        margin: 0;
        input {
          background-color: #ffffff;
          border-color: #b7b7b7;
          padding: 9px 18px;
        }
      }
      .cancelReason {
        width: 100%;
        background-color: #f5f5f5;
        padding: 30px 15px;
        margin-bottom: 25px;        
        fieldset {
          color: #000000;
          max-width: 340px;
          margin: 0 auto !important;
          .custom-control-label {
            line-height: 40px;
            &::after {
              top: 50%;
              margin-top: -8px;
            }
            &::before {
              border-color: #000000;
              top: 50%;
              margin-top: -8px;
            }            
          }          
          .was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, 
          .custom-control-input.is-valid:focus ~ .custom-control-label::before {
            box-shadow: none;
          }
          .was-validated .custom-control-input:valid ~ .custom-control-label, 
          .custom-control-input.is-valid ~ .custom-control-label {
            color: #000000;
          }
          .was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, 
          .custom-control-input.is-valid:checked ~ .custom-control-label::before {
            border-color: #000000;
            background-color: #ffffff;
          }
          .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
              background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000'/%3e%3c/svg%3e");
          }
          .was-validated .custom-control-input:invalid ~ .custom-control-label, 
          .custom-control-input.is-invalid ~ .custom-control-label {
            color: #000000;
          }
          .was-validated .custom-control-input:invalid ~ .custom-control-label::before, 
          .custom-control-input.is-invalid ~ .custom-control-label::before {
            border-color: #000000;
          }
        }
      }
    }
    h2 {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 30px;
      img {
        margin: 0 12px;
        vertical-align: -0.2rem;
      }
    }
  }
}

.entrance {
  transition: opacity .15s linear;
  .slide-in-left {
    animation: slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.manager-subscriptions {
  margin: initial;  
  padding: 50px 0;
  padding-left: 7%;
  height: 100%;
  h2 {
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 35px;
  }
  p {
    color: #000000;
    font-size: 20px;
    font-weight: 700;
  }
  .history-table {
    font-size: 18px;
    background: #ffffff;
    color: #000000;
    border-top: 1px solid #b3b3b3;
    //max-width: 935px;
    &:last-child  {
      border-bottom: 1px solid #b3b3b3;
    }
    .row {
      min-height: 83px;
      align-items: center;
      .col {        
        align-self: center;
        padding: 1.25rem 1.5625rem
      }
    }

    .itens {
      display: flex;
      font-size: 18px;
      font-weight: 400;
      margin: 0 1.5625rem;
      svg {
        width: 16px;
        margin-right: 15px;
      }
    }
    .plans {
      font-size: 16px;
      font-weight: 400;
      margin: 0;
      text-align: right;
      .payment {
        color: #808080;
      }
    }
    .change-plan {
      border-left: 1px solid #d7d7d7;      
      color: #ee4586;
      font-size: 16px;
      padding-left: 15px;
      margin-left: 15px;
    }
    .button {
      padding: 0;
    }
    .nav-pills {
      .show > .nav-link {  
        background-color: #EDEDED;
      }
      .nav-link {
        width: 43px;
        height: 43px;
        text-align: center;
        padding: 6px;
        span {
          background: url(https://api.iconify.design/carbon:overflow-menu-vertical.svg) no-repeat center center/contain;
          width: 30px;
          height: 30px;
          display: block;
        }
        &.active {
          background-color: #EDEDED;
        }
      }
      .dropdown-menu {
        font-size: 16px;
        text-align: right;
        line-height: 36px;
        .dropdown-item {
          color: #000000;
          padding: 0 1.5rem;
        }
        .dropdown-item.active, 
        .dropdown-item:active {
          background-color: transparent;
        }
        .dropdown-item.disabled {
          color: lightgray;
        }
      }
    }    
    .dropdown-toggle::after {      
      display: none
    }
  }
  .others-products {
    padding-top: 50px;
  }
}

@media screen and (max-width: 775px) {
  .manager-subscriptions {
    margin-left: 0;
  }
  #modalCancelSubscriptionCentre {
    .modal-dialog {
      form {
        font-size: 16px;
      }
      h2 {
        font-size: 22px;
      }
      .modal-footer {
        padding: 0px 30px;
      }
    }
    
  }
}

</style>
